export const submissionsSelector = (submissionsObj) => {
  return Object.keys(submissionsObj)
    .map((submissionKey) => submissionsObj[submissionKey]);
};
